import { render, staticRenderFns } from "./aPricingStrategyGridRulesGridHeader.vue?vue&type=template&id=4b04bc74&scoped=true"
import script from "./aPricingStrategyGridRulesGridHeader.vue?vue&type=script&lang=js"
export * from "./aPricingStrategyGridRulesGridHeader.vue?vue&type=script&lang=js"
import style0 from "./aPricingStrategyGridRulesGridHeader.vue?vue&type=style&index=0&id=4b04bc74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b04bc74",
  null
  
)

export default component.exports